import { Loader2, Trash2 } from "lucide-react";
import { motion } from "framer-motion";


const DeletePopupButtonSection = ({ onCancel, onClose, handleDeleteConfirm }) => {

    return ( <div className="flex justify-center space-x-3">
        <button
            onClick={onCancel || onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
            Cancel
        </button>
        <button
            onClick={handleDeleteConfirm}
            className="px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
        >
            Delete
        </button>
    </div>)
}


const DeletePopup = ({ 
    title = "Delete Confirmation",
    message = "Are you sure you want to delete this item? This action cannot be undone.",
    onConfirm,
    onCancel,
    onClose,
    loading,
    deleteSuccess,
    deleteSuccessMessage = "Resume deleted successfully",
    deletingError = ""
}) => {


    const handleDeleteConfirm = () => {
        if (onConfirm) {
            onConfirm();
        }
        
    };

    const renderBottomSection = () => {
        if(loading){
            return <div className="w-full flex justify-center items-center">
                <Loader2 className="h-6 w-6 text-gray-500 animate-spin" />
            </div>
        }
        if(deleteSuccess){
            return (<div className="flex flex-col justify-center items-center w-full">
            <motion.svg
                animate={{ scale: [1, 1.5, 1] }}
                transition={{ duration: 0.8, repeat: Infinity, ease: "easeInOut" }}
                className="w-8 h-8 text-green-500"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                >
                <polyline points="20 6 9 17 4 12" />
            </motion.svg>
            <p className="text-lg text-green-500 ml-2">{deleteSuccessMessage}</p>
          </div>)
        }
        return <DeletePopupButtonSection onCancel={onCancel} onClose={onClose} handleDeleteConfirm={handleDeleteConfirm} />
    }

    return (
        <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
                <Trash2 className="h-6 w-6 text-red-600" />
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">
                {title}
            </h3>
            {message}
            {!deleteSuccess && deletingError && <p className="text-sm text-red-500 mb-6">{deletingError}</p>}
            {renderBottomSection()}
           
        </div>
    );
};

export default DeletePopup; 